import { DEFAULT_TENANT, TENANTS, type Tenant, tenantSchema } from "./tenant"

const getTenant = (): Tenant => {
  const raw = process.env.NEXT_PUBLIC_TENANT
  if (raw === undefined || raw === "") return DEFAULT_TENANT
  const parsed = tenantSchema.safeParse(raw)
  if (!parsed.success) {
    throw new Error(
      `NEXT_PUBLIC_TENANT is "${raw}". ` +
        `Expected one of: ${TENANTS.join(", ")}, or unset (defaults to "${DEFAULT_TENANT}").`,
    )
  }
  return parsed.data
}

export default getTenant
